import { Injectable } from '@angular/core';
import { mapFetchResultData } from '@x/common/graph';
import { Observable } from 'rxjs';
import {
  ShopShippingMethodGQL,
  ShopShippingMethodsGQL,
  ShopShippingMethodsWithCollectionsGQL,
} from './gql/shop-shipping-method.gql.generated';
import {
  IShopShippingMethod,
  IShopShippingMethodQuery,
  IShopShippingMethodsQuery,
} from './types/shop-shipping-method';

@Injectable()
export class ShopShippingMethodService {
  constructor(
    private shopShippingMethodsGQL: ShopShippingMethodsGQL,
    private shopShippingMethodGQL: ShopShippingMethodGQL,
    private shopShippingMethodsWithCollectionsGQL: ShopShippingMethodsWithCollectionsGQL,
  ) {}

  fetchShippingMethodById(query: IShopShippingMethodQuery): Observable<IShopShippingMethod> {
    return this.shopShippingMethodGQL
      .fetch(query)
      .pipe(mapFetchResultData((r) => r.shopShippingMethod));
  }

  fetchShippingMethods(query: IShopShippingMethodsQuery): Observable<IShopShippingMethod[]> {
    return this.shopShippingMethodsGQL
      .fetch(query)
      .pipe(mapFetchResultData((r) => r.shopShippingMethods));
  }

  shippingMethodsHasCollections(orderId: number): Observable<boolean> {
    return this.shopShippingMethodsWithCollectionsGQL
      .fetch({ orderId })
      .pipe(mapFetchResultData((r) => r.shopShippingMethods.length > 0));
  }
}
